const translation = {
  createApp: 'Створити додаток',
  types: {
    all: 'Усе',
    chatbot: 'Чатбот',
    agent: 'Агент',
    workflow: 'Робочий процес',
    completion: 'Завершення',
  },
  duplicate: 'Дублювати',
  duplicateTitle: 'Дублювати додаток',
  export: 'Експортувати DSL',
  exportFailed: 'Не вдалося експортувати DSL.',
  importDSL: 'Імпортувати файл DSL',
  createFromConfigFile: 'Створити з файлу DSL',
  deleteAppConfirmTitle: 'Видалити цей додаток?',
  deleteAppConfirmContent:
    'Видалення додатка незворотнє. Користувачі більше не зможуть отримати доступ до вашого додатка, і всі налаштування запитів та журнали будуть остаточно видалені.',
  appDeleted: 'Додаток видалено',
  appDeleteFailed: 'Не вдалося видалити додаток',
  join: 'Приєднуйтесь до спільноти',
  communityIntro:
    'Обговорюйте з членами команди, співавторами та розробниками на різних каналах.',
  roadmap: 'Переглянути наш план розвитку',
  newApp: {
    startFromBlank: 'Створити з нуля',
    startFromTemplate: 'Створити з шаблону',
    captionAppType: 'Який тип додатка ви хочете створити?',
    chatbotDescription: 'Побудуйте додаток на основі чату. Цей додаток використовує формат запитань та відповідей, що дозволяє проводити кілька раундів безперервного спілкування.',
    completionDescription: 'Побудуйте додаток, який генерує текст високої якості на основі підказок, таких як генерація статей, резюме, перекладів тощо.',
    completionWarning: 'Цей тип додатка більше не буде підтримуватися.',
    agentDescription: 'Побудуйте інтелектуального агента, який може автономно обирати інструменти для виконання завдань',
    workflowDescription: 'Побудуйте додаток, який генерує текст високої якості на основі робочого процесу з високим рівнем настроювання. Він підходить для досвідчених користувачів.',
    workflowWarning: 'Наразі в бета-версії',
    chatbotType: 'Метод оркестрації чатботу',
    basic: 'Базовий',
    basicTip: 'Для початківців, можна перейти до Chatflow пізніше',
    basicFor: 'ДЛЯ ПОЧАТКІВЦІВ',
    basicDescription: 'Базовий оркестр дозволяє оркеструвати додаток чатбота за допомогою простих налаштувань, без можливості змінювати вбудовані підказки. Він підходить для початківців.',
    advanced: 'Chatflow',
    advancedFor: 'Для досвідчених користувачів',
    advancedDescription: 'Оркестрування робочого процесу оркеструє чатботи у формі робочих процесів, пропонуючи високий рівень настроювання, включаючи можливість редагувати вбудовані підказки. Він підходить для досвідчених користувачів.',
    captionName: 'Іконка та назва додатка',
    appNamePlaceholder: 'Дайте назву вашому додатку',
    captionDescription: 'Опис',
    appDescriptionPlaceholder: 'Введіть опис додатка',
    useTemplate: 'Використовуйте цей шаблон',
    previewDemo: 'Попередній перегляд демонстрації',
    chatApp: 'Асистент',
    chatAppIntro:
      'Я хочу побудувати додаток на основі чату. Цей додаток використовує формат запитань та відповідей, що дозволяє проводити кілька раундів безперервного спілкування.',
    agentAssistant: 'Новий помічник агента',
    completeApp: 'Генератор тексту',
    completeAppIntro:
      'Я хочу створити додаток, який генерує текст високої якості на основі підказок, таких як генерація статей, резюме, перекладів тощо.',
    showTemplates: 'Я хочу вибрати з шаблону',
    hideTemplates: 'Повернутися до вибору режиму',
    Create: 'Створити',
    Cancel: 'Скасувати',
    nameNotEmpty: 'Назва не може бути порожньою',
    appTemplateNotSelected: 'Будь ласка, виберіть шаблон',
    appTypeRequired: 'Будь ласка, виберіть тип додатка',
    appCreated: 'Додаток створено',
    appCreateFailed: 'Не вдалося створити додаток',
  },
  editApp: 'Редагувати інформацію',
  editAppTitle: 'Редагувати інформацію про додаток',
  editDone: 'Інформація про додаток оновлена',
  editFailed: 'Не вдалося оновити інформацію про додаток',
  emoji: {
    ok: 'OK',
    cancel: 'Скасувати',
  },
  switch: 'Перейти до оркестрації робочого процесу',
  switchTipStart: 'Для вас буде створена нова копія додатка, і нова копія перейде до оркестрації робочого процесу. Нова копія не дозволить ',
  switchTip: 'повернутися',
  switchTipEnd: ' до базової оркестрації.',
  switchLabel: 'Копія додатка, яка буде створена',
  removeOriginal: 'Видалити початковий додаток',
  switchStart: 'Почати перемикання',
  typeSelector: {
    all: 'Усі типи',
    chatbot: 'Чатбот',
    agent: 'Агент',
    workflow: 'Робочий процес',
    completion: 'Завершення',
  },
}

export default translation
